import { useEffect, useRef } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import tractoricon from '../assets/niches/tractor.svg';
import usersicon from '../assets/niches/users.svg';
import graduationcapicon from '../assets/niches/graduation-cap.svg';
import houseicon from '../assets/niches/house.svg';
import building2icon from '../assets/niches/building-2.svg';
import hotelicon from '../assets/niches/hotel.svg';
import gavelicon from '../assets/niches/gavel.svg';
import workingfactoryicon from '../assets/niches/working-factory-svgrepo-com 1.svg';
import pickaxeicon from '../assets/niches/pickaxe.svg';
import hamburgericon from '../assets/niches/hamburger.svg';
import landmarkicon from '../assets/niches/landmark.svg';
import phonecallicon from '../assets/niches/phone-call.svg';
import storeicon from '../assets/niches/store.svg';
import hospitalicon from '../assets/niches/hospital.svg';
import shoppingcarticon from '../assets/niches/shopping-cart.svg';
import piggybankicon from '../assets/niches/piggy-bank.svg';
import monitorplayicon from '../assets/niches/monitor-play.svg';
import houseplugicon from '../assets/niches/house-plug.svg';

// Register GSAP plugins
gsap.registerPlugin(ScrollTrigger);

const Niches = () => {
  const sectionRef = useRef(null);
  const gridRef = useRef(null);

  // Niche items with their corresponding SVG icons in German
  const nicheItems = [
    { text: 'Landwirtschaft', icon: tractoricon },
    { text: 'Human Resources', icon: usersicon },
    { text: 'Bildung', icon: graduationcapicon },
    { text: 'Versicherung', icon: houseicon },
    { text: 'Immobilien', icon: building2icon },
    { text: 'Hotellerie', icon: hotelicon },
    { text: 'Recht', icon: gavelicon },
    { text: 'Industrie', icon: workingfactoryicon },
    { text: 'Bauwesen', icon: pickaxeicon },
    { text: 'Gastronomie', icon: hamburgericon },
    { text: 'Gemeinden', icon: landmarkicon },
    { text: 'Telekommunikation', icon: phonecallicon },
    { text: 'Einzelhandel', icon: storeicon },
    { text: 'Gesundheitswesen', icon: hospitalicon },
    { text: 'E-Commerce', icon: shoppingcarticon },
    { text: 'Finanzen', icon: piggybankicon },
    { text: 'Marketing', icon: monitorplayicon },
    { text: 'Energie', icon: houseplugicon },

  ].map(item => ({
    ...item,
    icon: (
      <img
        src={item.icon}
        alt={item.text}
        width="32"
        height="32"
        className="text-white"
      />
    )
  }));

  // Animation setup
  useEffect(() => {
    const cards = gridRef.current?.children;
    if (!cards) return;

    // Set initial positions - alternating columns pattern for both rows
    gsap.set(cards, {
      y: (index) => {
        const columnIndex = index % 9; // Which column (0,1,2,3,4,5,6,7,8)
        return columnIndex % 2 === 0 ? 60 : 0; // Columns 0,2,4,6,8 have 60px offset, columns 1,3,5,7 stay at 0
      },
      opacity: 0.7
    });

    // Create timeline for smooth animation
    const tl = gsap.timeline({
      scrollTrigger: {
        trigger: sectionRef.current,
        start: "top 70%",
        end: "center 30%",
        scrub: 1.5,
        markers: false
      }
    });

    // Animate cards to final positions - NO STAGGER, all move together
    tl.to(cards, {
      y: 0,
      opacity: 1,
      duration: 1,
      ease: "power2.out"
      // No stagger - all cards move in sync
    });

    return () => {
      ScrollTrigger.getAll().forEach(trigger => trigger.kill());
    };
  }, []);

  return (
    <section ref={sectionRef} className="bg-[#010003] text-white px-4 py-20 mt-[-600px] md:mt-[-600px] relative z-30">
      <div className="w-full text-center relative z-10">
        <div className="flex flex-col items-center justify-center">
          <div ref={gridRef} className="grid grid-cols-3 sm:grid-cols-5 md:grid-cols-7 lg:grid-cols-9 gap-2 sm:gap-4 justify-items-center w-full max-w-[300px] sm:max-w-[640px] md:max-w-[1000px] lg:max-w-[1600px] mx-auto px-4">
          {nicheItems.map((item, index) => (
            <div
              key={index}
              className="bg-[#0D0E12] rounded-lg w-[80px] h-[80px] sm:w-[120px] sm:h-[120px] md:w-[140px] md:h-[140px] lg:w-[160px] lg:h-[160px] flex flex-col items-center justify-center gap-1 sm:gap-2 p-2"
            >
              <div className="w-4 h-4 sm:w-8 sm:h-8">
                {item.icon}
              </div>
              <span className="font-['Geist'] text-[8px] font-light text-[#787c87] sm:text-[12px]">
                {item.text}
              </span>
            </div>
          ))}
          </div>
        </div>
      </div>

      {/* Spotlight Effect - Radial Gradient Overlay */}
      <div
        className="absolute inset-0 z-40 pointer-events-none"
        style={{
          background: `radial-gradient(circle at 50% 50%, transparent 0%, transparent 15%, rgba(1, 0, 3, 0.3) 25%, rgba(1, 0, 3, 0.8) 40%, #010003 60%)`
        }}
        aria-hidden="true"
      ></div>
    </section>
  );
};

export default Niches;
